import { RouteConfig } from 'vue-router';
import PanelDashboards from './pages/PanelDashboards.vue';
import PanelDashboard from './pages/PanelDashboard.vue';
import { PermissionTypeEnum } from '@/libs/Api';

export default [
    {
        path: '/:tenantId/panel-dashboards',
        name: 'PanelDashboards',
        component: PanelDashboards,
        props: (route) => ({ tenantId: route.params.tenantId }),
        meta: {
            permissions: [
                PermissionTypeEnum.Admin,
                PermissionTypeEnum.AdminGroups,
                PermissionTypeEnum.PanelDashboardEdit,
                PermissionTypeEnum.PanelDashboardView,
            ],
            checkLicence: true,
            title: 'menu.panelDashboards',
        },
    },
    {
        path: '/:tenantId/panel-dashboards/:panelId',
        name: 'PanelDashboard',
        component: PanelDashboard,
        props: (route) => ({ tenantId: route.params.tenantId, panelId: route.params.panelId }),
        meta: {
            permissions: [
                PermissionTypeEnum.Admin,
                PermissionTypeEnum.AdminGroups,
                PermissionTypeEnum.PanelDashboardEdit,
                PermissionTypeEnum.PanelDashboardView,
            ],
            checkLicence: true,
        },
    },
] as RouteConfig[];
